import React from 'react';
import { dummyClick } from '../utilities';

const MobileIcon = ({ onClick }) => (
  <div className="mt5 left a-mobile-pop-logo md-hide lg-hide">
    <a className="a-inner-link" href={EMPTY_HREF} onClick={e => { e.preventDefault(); onClick() }}></a>
  </div>
);

MobileIcon.defaultProps = {
  onClick: dummyClick
};

export default MobileIcon;
